// extracted by mini-css-extract-plugin
export default {"body":"Body_body__6VRZZ","paddedBox":"Body_paddedBox__S0iVp"};